import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'store';
import { getTraineeChats, getChatsUsingRoomId, addChat } from 'store/reducers/chat';
import PrivateChatList from './PrivateChatList';
import ChatArea from './ChatArea';
import { filterParticipantSearch } from 'utils/chatHelperFunction';
import { validateAndCreateSocketIfExist } from 'utils/SocketValidator';
import { transformSocketMessage } from 'middlewares/transform/chat';
import { UserInfoMapperSocketHandler } from 'utils/UserInfoMapper';
import { IMessage } from 'models';
import { useLocation } from 'react-router-dom';
import ChatService from 'services/Chat';
import PrivateChatSwitch from './PrivateChatSwitch';
import { resetPrivateCount } from 'store/reducers/countReducer';

const PrivateChat: React.FC<any> = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { user } = useSelector((state: RootState) => state.auth);
  const { messages, error } = useSelector((state: RootState) => state.live.chats);
  const [searchQuery, setSearchQuery] = useState('');
  const [startChatParticipant, setStartChatParticipant] = useState<any | null>(null);
  const userInfoHandler = useRef<UserInfoMapperSocketHandler | null>(null);
  const messageCountData = useSelector((state: any) => state.countReducer);
  const batchData = useSelector((state: RootState) => state.live.settings.batch);
  const [userList, setUserList] = useState<any[]>([]);
  const [messageBoxSnap, setMessageBoxSnap] = useState<any[]>([]);
  const countReducer = useSelector((state: any) => state.countReducer);
  const participantData: any = useSelector((state: any) => state.live.settings.batch.participants);
  const _participantData = participantData?.filter((x: any) => x?.email?.toLowerCase() == user.email?.toLowerCase());
  const senderData = _participantData?.length > 0 ? _participantData[0] : {};
  const location = useLocation();
  const [searchToStartChat, setSearchToStartChat] = useState(false);
  const allParticipants = batchData?.participants?.map((item: any) => item.name?.toLowerCase());
  const [userName, setUserName] = useState('');
  const chatService = new ChatService();
  const roomId = useSelector((state: RootState) => state.live.settings.roomId);
  const [selectedChatItem, setSelectedChatItem] = useState<any | null>(null);


  const handleSearchChange = (value: string) => {
    setSearchQuery(value);

    // Check if the input value is a substring of any participant's name
    const matchedParticipant = batchData?.participants?.find((p: any) =>
      p.name?.toLowerCase().includes(value.toLowerCase())
    );

    if (matchedParticipant) {
      setSearchToStartChat(true);
      setUserName(matchedParticipant.name);
      setStartChatParticipant(matchedParticipant);
    } else {
      setUserName('');
      setSearchToStartChat(false);
      setStartChatParticipant(null);
    }

    handleSearch(value);
  };

  const getUserList = () => {
    let request = {
      traineeId: senderData.id,
      session_map_id: parseInt(roomId),
    };
    chatService.getTraineeChats(request).then((response: any) => {
      var privateCount = messageCountData?.private;
      for (let i = 0; i < privateCount.length; i++) {
        const countItem = privateCount[i];
        for (let j = 0; j < response.length; j++) {
          if (countItem.id === response[j].room_id) {
            response[j].count = countItem.count;
          }
        }
      }
      if (response && typeof response === 'object') {
        setUserList(response);
        setMessageBoxSnap(response);
      }
    }).catch((error: any) => {
    });
  };

  const handleSearch = (value: string) => {
    setSearchQuery(value);
    if (!value || value === '') {
      setUserList(messageBoxSnap ?? []);
    } else {
      const searchMsg = userList?.filter((x: any) => {
        return (
          (x?.users?.[0]?.name && x.users[0].name.toLowerCase().includes(value.toLowerCase())) ||
          (x?.users?.[1]?.fullname && x.users[1].fullname.toLowerCase().includes(value.toLowerCase()))
        );
      });
      setUserList(searchMsg ?? []);
    }
  };

  useEffect(() => {
    getUserList();
  }, [location.pathname]);

  useEffect(() => {
    var privateCount = countReducer.private;
    if (privateCount.length > 0) {
      for (let i = 0; i < privateCount.length; i++) {
        const countItem = privateCount[i];
        for (let j = 0; j < userList.length; j++) {
          const dataItem = userList[j];
          if (countItem.id === dataItem.room_id) {
            dataItem.count = countItem.count;
          }
        }
      }
      setUserList([...userList]); // Trigger re-render
    }
  }, [countReducer]);


  const resetPrivateChat = (id: any) => {
    dispatch(resetPrivateCount(id));
  };

  const onPressChat = (item: any) => {
    item.type = 'private';

    resetPrivateChat(item.room_id);
    // setOpenPrivateChat({
    //   ...item.users.find((u: any) => u.id !== senderData.id),
    //   room_id: item.room_id,
    // });
    handleSearchChange('');
    setSelectedChatItem(item);

  };

  const renderItem = (item: any) => {
    let _userName = item.users?.filter((x: any) => x?.id !== senderData?.id)?.map((y: any) => y?.name || y?.fullname);
    let userName = _userName?.toString() || '';
    let _profilePhoto = item.users
      ?.filter((x: any) => x?.id !== senderData?.id)
      ?.map((y: any) => y?.profilePhoto)[0];
    let matched = item.users?.filter((x: any) => String(x?.id) === String(senderData?.id));

    if (userName && matched.length > 0) {
      return (
        <div
          key={item.room_id}
          className="flex flex-row items-center bg-[#5B5D6B] border border-[#E6DDF8] p-2 m-2 rounded-lg cursor-pointer"
          onClick={() => onPressChat(item)}
        >
          <div className="w-10 h-10 rounded-full bg-gray-400 flex items-center justify-center text-white font-bold mr-3">
            {userName
              .split(" ")
              .map((n) => n[0])
              .join("")
              .toUpperCase()
              .slice(0, 2)}
          </div>
          <div className="flex-1">
            <span className="text-white italic font-semibold">{userName}</span>
          </div>
          {item.count ? (
            <div className="bg-red-600 text-white text-xs font-bold rounded-full w-6 h-6 flex items-center justify-center">
              {item.count <= 9 ? `0${item.count}` : item.count}
            </div>
          ) : null}
        </div>
      );
    }
    return null;
  };

  return (
    <div className="flex flex-col flex-1">
      {selectedChatItem ? (
        <PrivateChatSwitch item={selectedChatItem} />
      ) : (<>
        {error && <div className="text-red-500 p-2 text-center">{error}</div>}
        <div className="flex flex-col w-[90%] mx-auto">
          <div className="flex items-center p-2 m-2 rounded-[4px] border border-[#3B4350] bg-[#24272C] shadow-[inset_-5px_-5px_20px_rgba(255,255,255,0.25),inset_5px_5px_20px_rgba(0,0,0,0.25)]">
            <input
              type="text"
              className="flex-1 outline-none text-gray-200 placeholder-[#D4D6DB] bg-transparent"
              placeholder="Search messages..."
              value={searchQuery}
              onChange={(e) => handleSearchChange(e.target.value)}
            />
            <svg
              className="w-5 h-5 text-gray-400 mr-2"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              />
            </svg>
          </div>
          {searchToStartChat && (
            <div className="flex justify-between border border-[#E6DDF8] bg-[#5B5D6B] p-3 m-2 rounded-lg shadow-md">
              <span className="text-white italic font-semibold">{userName}</span>
              <button
                className="text-white font-medium hover:text-[#5F488A]"
                onClick={() => {
                  let updatedSearch = batchData.participants.filter((item) => item.name == userName)
                  let searchedMemberDetail = { users: updatedSearch }
                  onPressChat(searchedMemberDetail)
                }}
              >
                Start Chat
              </button>
            </div>
          )}
          <div className="flex flex-col mt-2">
            {userList.length > 0 ? (
              userList.map((item) => renderItem(item))
            ) : (
              <div className="text-gray-500 text-center p-4">
                You are yet to start private chat with anyone.
              </div>
            )}
          </div>
        </div>
      </>
      )}
    </div>
  );
};

export default PrivateChat;